import type Uppy from '@uppy/core';

export const countActiveFiles = (uppy: Uppy) =>
  uppy
    .getFiles()
    .filter(
      (file) => file.progress.uploadStarted !== null && !file.progress.complete,
    ).length;
